export interface ICampoDisponivel {
  id: string;
  nome: string;
}

export const CAMPOS_DISPONIVEIS: ICampoDisponivel[] = [
  { id: "Ciclo", nome: "Ciclo" },
  { id: "Cliente", nome: "Cliente" },
  { id: "Documento", nome: "Documento" },
  { id: "Instalacao", nome: "Instalacao" },
  { id: "Classe", nome: "Classe" },
  { id: "TipoClasse", nome: "TipoClasse" },
  { id: "Codigo_Externo", nome: "Codigo_Externo" },
  { id: "Forma_de_Faturamento", nome: "Forma_de_Faturamento" },
  { id: "Parceiro", nome: "Parceiro" },
  { id: "Concessionaria", nome: "Concessionaria" },
  { id: "Usina", nome: "Usina" },
  { id: "Tipo_da_Usina", nome: "Tipo_da_Usina" },
  { id: "Empresa_Usina", nome: "Empresa_Usina" },
  { id: "Status_Fatura_Prevista", nome: "Status_Fatura_Prevista" },
  { id: "Status_Fatura_Instalacao", nome: "Status_Fatura_Instalacao" },
  { id: "Publicacao", nome: "Publicacao" },
  { id: "Regra_de_Calculo", nome: "Regra_de_Calculo" },
  { id: "Energia_Injetada_kWh", nome: "Energia_Injetada_kWh" },
  { id: "Injecao_Prevista_kWh", nome: "Injecao_Prevista_kWh" },
  { id: "Injecao_de_3s_kWh", nome: "Injecao_de_3s_kWh" },
  { id: "Diferenca_Porcentagem", nome: "Diferenca_Porcentagem" },
  { id: "Injecao_Alsol_kWh", nome: "Injecao_Alsol_kWh" },
  { id: "Diferenca_Injecao", nome: "Diferenca_Injecao" },
  { id: "Energia_Compensada_kWh", nome: "Energia_Compensada_kWh" },
  { id: "Dispo_Energia_Concessionaria_kWh", nome: "Dispo_Energia_Concessionaria_kWh" },
  { id: "Valor_Dispo_Energia_Concessionaria_Real", nome: "Valor_Dispo_Energia_Concessionaria_Real" },
  { id: "Consumo_kWh", nome: "Consumo_kWh" },
  { id: "Conferencia", nome: "Conferencia" },
  { id: "Saldo_Consolidado_Anterior", nome: "Saldo_Consolidado_Anterior" },
  { id: "Saldo_Consolidado_Atual", nome: "Saldo_Consolidado_Atual" },
  { id: "Saldo_Anterior_Terceiros", nome: "Saldo_Anterior_Terceiros" },
  { id: "Saldo_Anterior_Alsol", nome: "Saldo_Anterior_Alsol" },
  { id: "Saldo_Anterior_Concessionaria", nome: "Saldo_Anterior_Concessionaria" },
  { id: "Saldo_Anterior_Rebalance", nome: "Saldo_Anterior_Rebalance" },
  { id: "Saldo_Atual_Terceiros", nome: "Saldo_Atual_Terceiros" },
  { id: "Saldo_Atual_Alsol", nome: "Saldo_Atual_Alsol" },
  { id: "Saldo_Atual_Concessionaria", nome: "Saldo_Atual_Concessionaria" },
  { id: "Saldo_Atual_Rebalance", nome: "Saldo_Atual_Rebalance" },
  { id: "Diferenca_de_Saldo_Consolidado", nome: "Diferenca_de_Saldo_Consolidado" },
  { id: "Diferenca_de_Saldo_Terceiros", nome: "Diferenca_de_Saldo_Terceiros" },
  { id: "Diferenca_de_Saldo_Alsol", nome: "Diferenca_de_Saldo_Alsol" },
  { id: "Diferenca_de_Saldo_Concessionaria", nome: "Diferenca_de_Saldo_Concessionaria" },
  { id: "Diferenca_de_Saldo_Rebalance", nome: "Diferenca_de_Saldo_Rebalance" },
  { id: "Porcentagem_Saldo_Alsol", nome: "Porcentagem_Saldo_Alsol" },
  { id: "Porcentagem_Saldo_Concessionaria", nome: "Porcentagem_Saldo_Concessionaria" },
  { id: "Porcentagem_Saldo_Rebalance", nome: "Porcentagem_Saldo_Rebalance" },
  { id: "Creditos_do_mes_kWh", nome: "Creditos_do_mes_kWh" },
  { id: "Tarifa_Cemig", nome: "Tarifa_Cemig" },
  { id: "Tarifa_Alsol", nome: "Tarifa_Alsol" },
  { id: "Tarifa_Cobrada", nome: "Tarifa_Cobrada" },
  { id: "Tarifa_Concessionaria_Utilizada", nome: "Tarifa_Concessionaria_Utilizada" },
  { id: "Desconto_Contratado", nome: "Desconto_Contratado" },
  { id: "Desconto_Faturado", nome: "Desconto_Faturado" },
  { id: "Bonificacao_kWh", nome: "Bonificacao_kWh" },
  { id: "Bonificacao_Real", nome: "Bonificacao_Real" },
  { id: "Acrescimo_kWh", nome: "Acrescimo_kWh" },
  { id: "Acrescimo_Real", nome: "Acrescimo_Real" },
  { id: "Creditos_Faturados_kWH", nome: "Creditos_Faturados_kWH" },
  { id: "Valor_Alsol_Real", nome: "Valor_Alsol_Real" },
  { id: "Vencimento_Alsol", nome: "Vencimento_Alsol" },
  { id: "Vencimento_Concessionaria", nome: "Vencimento_Concessionaria" },
  { id: "Valor_dos_creditos_na_concessionaria_Real", nome: "Valor_dos_creditos_na_concessionaria_Real" },
  { id: "Valor_da_Fatura_na_concessionaria_Real", nome: "Valor_da_Fatura_na_concessionaria_Real" },
  { id: "Valor_Alsol_Concessionaria_Real", nome: "Valor_Alsol_Concessionaria_Real" },
  { id: "PIS_COFINS_Real", nome: "PIS_COFINS_Real" },
  { id: "Taxa_de_Iluminacao_Publica_Real", nome: "Taxa_de_Iluminacao_Publica_Real" },
  { id: "Demais_encargos_Real", nome: "Demais_encargos_Real" },
  { id: "Abatimentos_e_devolucoes_Real", nome: "Abatimentos_e_devolucoes_Real" },
  { id: "Debito_Automatico", nome: "Debito_Automatico" },
  { id: "Valor_sem_Alsol_Real", nome: "Valor_sem_Alsol_Real" },
  { id: "Desconto_no_mes_Real", nome: "Desconto_no_mes_Real" },
  { id: "Desconto_no_mes_Porcentagem", nome: "Desconto_no_mes_Porcentagem" },
  { id: "Percepcao_da_Economia_do_mes_Porcentagem", nome: "Percepcao_da_Economia_do_mes_Porcentagem" },
  { id: "Valor_Fee_Real", nome: "Valor_Fee_Real" },
  { id: "Cobilling", nome: "Cobilling" },
  { id: "Cota_Original_kWp", nome: "Cota_Original_kWp" },
  { id: "Cota_Original_kWh", nome: "Cota_Original_kWh" },
  { id: "Porcentagem_Injecao_sobre_cota", nome: "Porcentagem_Injecao_sobre_cota" },
  { id: "PreBilling_Fatura_InstalacaoID", nome: "PreBilling_Fatura_InstalacaoID" },
  { id: "PreBilling_Fatura_ClienteID", nome: "PreBilling_Fatura_ClienteID" },
  { id: "Cor_Faturamento", nome: "Cor_Faturamento" },
  { id: "Data_Aprovacao", nome: "Data_Aprovacao" },
  { id: "Data_Conexao", nome: "Data_Conexao" },
  { id: "Data_Desconexao", nome: "Data_Desconexao" },
  { id: "Chave", nome: "Chave" },
  { id: "Economia_final_Real", nome: "Economia_final_Real" },
  { id: "Dispo_kWh", nome: "Dispo_kWh" },
  { id: "Porcentagem_Compensacao", nome: "Porcentagem_Compensacao" },
  { id: "Reducao_solicitacao", nome: "Reducao_solicitacao" },
  { id: "Range_de_compensacao", nome: "Range_de_compensacao" },
  { id: "MDC_3M", nome: "MDC_3M" },
  { id: "Saldo_nao_pago_MD", nome: "Saldo_nao_pago_MD" },
  { id: "Saldo_total_MD", nome: "Saldo_total_MD" },
  { id: "Range_Saldo_nao_pago", nome: "Range_Saldo_nao_pago" },
  { id: "Data_Leitura_Anterior", nome: "Data_Leitura_Anterior" },
  { id: "Data_Leitura_Atual", nome: "Data_Leitura_Atual" },
  { id: "Data_Proxima_Leitura", nome: "Data_Proxima_Leitura" },
  { id: "Data_Emissao_DISCO", nome: "Data_Emissao_DISCO" },
  { id: "Aliquota_ICMS", nome: "Aliquota_ICMS" },
  { id: "Aliquota_PIS", nome: "Aliquota_PIS" },
  { id: "Aliquota_COFINS", nome: "Aliquota_COFINS" },
  { id: "FlagCancelada", nome: "FlagCancelada" },
  { id: "Motivo_Alteracao_Flag_Cancelada", nome: "Motivo_Alteracao_Flag_Cancelada" },
  { id: "FormaDePagamento", nome: "FormaDePagamento" },
  { id: "RegraDataVencimento", nome: "RegraDataVencimento" },
  { id: "DataFixa", nome: "DataFixa" },


].sort((a, b) => a.nome.localeCompare(b.nome));
